import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronRightCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0m-2 0a14 14 0 1 0 28 0 14 14 0 0 0-28 0" />
    <path d="M13.3 9.3a1 1 0 0 0 0 1.4l5.3 5.3-5.3 5.3a1 1 0 0 0 0 1.4 1 1 0 0 0 1.4 0l6-6a1 1 0 0 0 0-1.4l-6-6a1 1 0 0 0-1.4 0" />
  </svg>
);
const ForwardRef = forwardRef(IconChevronRightCircleOutlineSVG);
ForwardRef.displayName = "IconChevronRightCircleOutline";
export { ForwardRef as IconChevronRightCircleOutline };
